import { DnsRecordStatus } from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

interface Props {
  status: DnsRecordStatus
  message: string
}

export const StatusIcon = ({ status, message }: Props) =>
  status === DnsRecordStatus.Healthy ? (
    <SvgIcon
      className="text-content-on-positive w-5 h-5"
      name="status-success"
    />
  ) : (
    <Tooltip>
      <Tooltip.Trigger>
        <SvgIcon className="text-content-on-attention w-5 h-5" name="info" />
      </Tooltip.Trigger>
      <Tooltip.Panel>{message}</Tooltip.Panel>
    </Tooltip>
  )
